import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AccountService, AlertService, UserService} from "../services";
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import {ServiceService} from "../services/service.service";
import {ComponentTitleService} from "../services/componentTitle.service";

import {locale as polish} from './i18n/pl';
import {locale as english} from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {CardOnline} from "../models/cardOnline";
import {MatDialog} from "@angular/material/dialog";
import {Items} from "../models/items";
import {Page} from "../models/page";
import {ReservationDataService} from "../services/reservationData.service";
import {ReservationsFilter} from "../models/reservationsFilter";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {Subject} from "rxjs";
import {User} from "../models";

@Component({
    templateUrl: './reservation.component.html',
    styleUrls: ['./reservation.component.scss']
})
export class ReservationComponent implements OnDestroy, OnInit {
    card9Expanded: boolean = false;
    view: string = 'preview';
    locale: string = 'pl';
    cards: CardOnline[];
    dialogRef: any;
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    page = new Page();
    userId: string;
    @ViewChild(DatatableComponent) table: DatatableComponent;
    user: User;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService,
        private route: ActivatedRoute,
        private serviceService: ServiceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private reservationService: ReservationDataService,
        public _matDialog: MatDialog,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;
        this.page.pageNumber = 0;
        this.page.size = 10;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        componentTitleService.clearTitle();
        componentTitleService.addPart('Reservations');

        this.translationLoader.loadTranslations(polish, english);
    }

    ngOnInit() {
        if (this.route.snapshot.params['id']) {
            this.userId = this.route.snapshot.params['id'];
            this.user = this.route.snapshot.data.userData;
        }

        this.setPage({offset: 0});
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    setPage(pageInfo) {
        this.loadingIndicator = true;
        this.rows = [];
        this.page.totalElements = 0;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }

        let filters = new ReservationsFilter();
        if (this.userId) {
            filters.customer = this.userId;
        }

        this.reservationService.getAllWithParams(pageInfo.offset * pageInfo.limit, pageInfo.limit, filters).pipe(first())
            .subscribe((res: Items) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.total;
                    // this.page = pagedData.page;
                },
                error => {
                    this.alertService.error(error);
                })
    }
}
